import React from "react"

interface IntentDirectionFilterProps {
  intentDirection: string
  onIntentDirectionChange: (intentDirection: string) => void
}

export const IntentDirectionFilter: React.FC<IntentDirectionFilterProps> = ({
  intentDirection,
  onIntentDirectionChange,
}) => {
  const intentDirections = [
    { code: "incoming", title: "Входящий" },
    { code: "outgoing", title: "Исходящий" },
  ]

  return (
    <div className="form-control flex-1 max-w-xs">
      <label htmlFor="intentDirection" className="label">
        <span className="label-text">Направление вызова</span>
      </label>
      <select
        id="intentDirection"
        name="intentDirection"
        className="select select-bordered"
        value={intentDirection || ""}
        onChange={e => onIntentDirectionChange(e.target.value)}
      >
        <option value="">Все</option>
        {intentDirections?.map(intentDirection => (
          <option key={intentDirection.code} value={intentDirection.code}>
            {intentDirection.title}
          </option>
        ))}
      </select>
    </div>
  )
}
